import { Nav } from "@/components/prometheus/Nav";
import { Footer } from "@/components/prometheus/Footer";
import { MakerSuite } from "@/components/prometheus/MakerSuite";
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const tabMap: Record<string, string> = {
  "cad_bridge": "cad_bridge",
  "fusion360": "cad_bridge",
  "fusion": "cad_bridge",
  "blender": "cad_bridge",
  "freecad": "cad_bridge",
  "kicad": "cad_bridge",
  "bambu": "cad_bridge",
  "bambustudio": "cad_bridge",
  "orcaslicer": "cad_bridge",
  "ingenieria": "cad_bridge",
  "engineering": "cad_bridge",
  "3d": "cad_bridge",
  "cad": "cad_bridge",
  "plano": "cad_bridge",
  "planos": "cad_bridge",
  "blueprint": "cad_bridge",
  "pics": "google_pics",
  "google_pics": "google_pics",
  "caratula": "google_pics",
  "caratulas": "google_pics",
  "faceplate": "google_pics",
  "faceplates": "google_pics",
  "rotulado": "google_pics",
  "serigrafia": "google_pics",
  "gear": "gear",
  "engranaje": "gear",
  "engranajes": "gear",
  "gcode": "gcode",
  "slicer": "gcode",
  "circuitos": "arduino",
  "circuit": "arduino",
  "arduino": "arduino",
  "esp32": "arduino",
  "wokwi": "arduino",
  "firmware": "arduino",
  "robotica": "arduino",
  "robotics": "arduino",
  "solar": "solar",
  "fotovoltaico": "solar",
  "paneles": "solar",
  "baterias": "solar",
  "bateria": "solar",
  "battery": "solar",
  "lifepo4": "solar",
  "apagon": "solar",
  "telemetria_bateria": "solar",
  "battery_telemetry": "solar",
  "quimica": "materials",
  "chemistry": "materials",
  "ciencia": "science_lab",
  "science": "science_lab",
  "science_lab": "science_lab",
  "laboratorio": "science_lab",
  "arquitectura": "architecture_suite",
  "architecture": "architecture_suite",
  "architecture_suite": "architecture_suite",
  "estructura": "architecture_suite",
  "cfd": "architecture_suite",
  "mathcode": "materials",
  "math": "materials",
  "materiales": "materials",
  "materials": "materials",
  "periodictable": "materials",
  "tabla": "materials",
  "inventario": "inventory",
  "inventory": "inventory",
  "abasto": "inventory",
  "compras": "inventory",
  "sourcing": "inventory",
  "lifecycle": "inventory",
  "bitacora": "inventory",
  "journal": "inventory",
  "roadmap": "inventory",
  "proyectos": "inventory",
  "fases": "inventory",
  "voz": "quicktools",
  "voice": "quicktools",
  "camara": "cad_bridge",
  "camera": "cad_bridge",
  "scanner": "cad_bridge",
  "vision": "cad_bridge",
  "fotogrametria": "cad_bridge",
  "escaner": "cad_bridge",
  "ocr": "cad_bridge",
  "knowledge": "materials",
  "boveda": "materials",
  "academia": "materials",
  "academy": "materials",
  "libros": "materials",
  "manuales": "materials",
  "pdf": "materials",
  "seguridad": "materials",
  "safety": "materials",
  "estructuras": "materials",
  "quicktools": "quicktools",
  "precision": "quicktools",
  "calculadora": "quicktools",
  "ohm": "quicktools",
  "resistencias": "quicktools",
  "bateria_duracion": "quicktools",
  "awg": "quicktools",
  "luma": "quicktools",
  "canvas": "canvas",
  "artifacts": "canvas",
  "editor": "canvas",
  "sandbox": "canvas",
  "acoustics": "quicktools",
  "acustica": "quicktools",
  "audio": "quicktools",
  "sonido": "quicktools",
  "fft": "quicktools",
  "transcribe": "quicktools",
  "mcp": "mcp",
  "protocol": "mcp",
  "hardwarehub": "mcp",
  "hub": "mcp",
  "webserial": "mcp",
  "usb": "mcp",
  "council": "council",
  "consejo": "council",
  "titanes": "council",
  "debate": "council",
  "multillm": "council",
  "lora": "lora",
  "mesh": "lora",
  "radio": "lora",
  "telemetria": "lora",
  "tactical": "lora",
  "vault": "lora",
  "spatial_house": "spatial_house",
  "spatial": "spatial_house",
  "casa3d": "spatial_house",
  "casa": "spatial_house",
  "roomplan": "spatial_house",
  "plano3d": "spatial_house",
  "planos3d": "spatial_house",
  "dollhouse": "spatial_house",
  "automation": "automation",
  "automatizacion": "automation",
  "flujo": "automation",
  "flow": "automation",
  "nodos": "automation",
  "devices": "automation",
  "dispositivos": "automation",
  "iot": "automation",
  "meshtastic": "lora",
  "us915": "lora",
  "antena": "lora",
  "brain3d": "brain3d",
  "brain": "brain3d",
  "cerebro": "brain3d",
  "3dbrain": "brain3d",
  "aisos": "brain3d",
  "segundocerebro": "brain3d",
};

const ToolsPage = () => {
  const { tab } = useParams<{ tab?: string }>();
  const [searchParams] = useSearchParams();
  const queryTab = searchParams.get("tab");
  const rawTab = (tab || queryTab || "").toLowerCase();
  const initialTab = rawTab ? (tabMap[rawTab] || rawTab) : undefined;

  useEffect(() => {
    document.title = "Herramientas — Prometheus Lab AI";
  }, []);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <Nav />
      <div className="pt-16">
        <MakerSuite initialTab={initialTab} />
      </div>
      <Footer />
    </main>
  );
};

export default ToolsPage;
